export const Box = ({ checked, onChange, text }) => {
  return (
    <div className="box-main">
      <label className="box-label">
        <p className="box-text">{text}</p>
        <input
          type="checkbox"
          value={text}
          checked={checked}
          onChange={e => onChange(e.target.value)}
        />
        <span className="box-box"></span>
      </label>
    </div>
  );
};
